import queryString from 'query-string';
import conf from '../config';
import { getOrganization } from './users';

const initialState = {
  models: {},
  searchedModels: {},
  perPage: 24,
};

const ADD_MODEL = 'ADD_MODEL';
const SET_MODELS = 'SET_MODELS';
const SET_REVIEW = 'SET_REVIEW';
const DELETE_MODEL = 'DELETE_MODEL';
const UPDATE_SEARCH_MODEL = 'UPDATE_SEARCH_MODEL';
const SET_SEARCH_MODELS = 'SET_SEARCH_MODELS';
const DELETE_SEARCH_MODEL = 'DELETE_SEARCH_MODEL';
const CLEAR_DATA = 'CLEAR_DATA';

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MODELS:
      const newModels = Object.assign({}, state.models, action.payload);
      return { ...state, models: newModels };
    case ADD_MODEL:
      const models = state.models;
      models[action.payload._id] = action.payload;
      return { ...state, models };
    case SET_REVIEW:
      const model = state.models[action.payload._id];
      model.preview = action.payload.preview;
      const updateModels = Object.assign({}, models, {
        [action.payload._id]: model,
      });
      return { ...state, models: updateModels };
    case DELETE_MODEL:
      const cuurentModels = state.models;
      delete cuurentModels[action.payload];
      return { ...state, models: cuurentModels };
    case SET_SEARCH_MODELS:
      return { ...state, searchedModels: action.payload };
    case UPDATE_SEARCH_MODEL:
      const searchedModels = state.searchedModels;
      searchedModels[action.payload._id] = action.payload;
      return { ...state, searchedModels };
    case DELETE_SEARCH_MODEL:
      const search = state.searchedModels;
      delete search[action.payload];
      return { ...state, searchedModels: search };
    case CLEAR_DATA:
      return initialState;
    default:
      return state;
  }
};

export const addModel = model => ({ type: ADD_MODEL, payload: model });
const setModels = models => ({ type: SET_MODELS, payload: models });

export const setSearchedModels = models => ({
  type: SET_SEARCH_MODELS,
  payload: models,
});

const updateSearchModels = model => ({
  type: UPDATE_SEARCH_MODEL,
  payload: model,
});

const deleteSearchModelFromState = id => ({
  type: DELETE_SEARCH_MODEL,
  payload: id,
});

export const getSearchedModels = state => state.models.searchedModels;

const setPreview = (_id, preview) => ({
  type: SET_REVIEW,
  payload: { _id, preview },
});

const deleteModelFromState = id => ({ type: DELETE_MODEL, payload: id });

export const getModels = (state, options = {}) => {
  const { tags, friendlyName } = options;
  if (!tags && !friendlyName) return state.models.models;
  const nameRegex = new RegExp(`^${friendlyName}`, 'i');
  const models = state.models.models;
  for (let i in models) {
    const model = models[i];
    if (tags && model.tags.indexOf(tags) === -1) delete models[i];
    if (friendlyName && !nameRegex.test(model.friendlyName)) delete models[i];
  }
  return models;
};

export function createModel(data) {
  return async (dispatch, getState) => {
    const state = getState();
    const organization = getOrganization(state);
    data.organization = organization && organization.slug;
    const result = await fetch(`${conf.apiRoot}/api/models`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(data),
    }).then(res => {
      if (res.status === 200) return res.json();
      return null;
    });
    if (result) {
      dispatch(addModel(result.model));
    }
  };
}

export function fetchModels(query = { page: 0 }, type) {
  return async (dispatch, getState) => {
    const state = getState();
    const results = getModels(state, {
      tags: query.tags,
      friendlyName: query.friendlyName,
    });
    const perPage = state.models.perPage;
    if (
      Object.keys(results).length > (query.page || 1) * perPage &&
      !query.tags &&
      !query.limit &&
      !query.friendlyName
    )
      return results;
    const organization = getOrganization(state);
    query.organization = organization && organization.slug;
    if (type === 'search') query.state = 'All';
    const models = await fetch(
      `${conf.apiRoot}/api/models?${queryString.stringify(query)}`,
      {
        credentials: 'include',
      }
    ).then(res => {
      if (res.status === 200) return res.json();
      return [];
    });
    const formatedModels = models.reduce((acc, el) => {
      acc[el._id] = el;
      return acc;
    }, {});
    if (type === 'search') {
      dispatch(setSearchedModels(formatedModels));
    } else {
      dispatch(setModels(formatedModels));
    }
    return formatedModels;
  };
}

export const getModel = id => async (dispatch, getState) => {
  const state = getState();
  const models = getModels(state);
  if (models[id]) return models[id];
  const model = await fetch(`${conf.apiRoot}/api/models/${id}`, {
    credentials: 'include',
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (model) dispatch(addModel(model));
  return model;
};

export const saveModel = (id, update) => async dispatch => {
  const result = await fetch(`${conf.apiRoot}/api/models/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(update),
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result && result.status === 'ok') {
    if (update.state === 'Discontinued') {
      dispatch(deleteModelFromState(id));
      dispatch(deleteSearchModelFromState(id));
    } else {
      dispatch(addModel(result.model));
      dispatch(updateSearchModels(result.model));
    }
  }
  return result;
};

export const saveModels = (ids, update) => async dispatch => {
  let result = { status: 'ok' };
  await Promise.all(ids.map(id => dispatch(saveModel(id, update))));
  return result;
};

export const getModelPreview = id => async dispatch => {
  const result = await fetch(`${conf.apiRoot}/api/models/${id}/previews`, {
    credentials: 'include',
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result) dispatch(setPreview(id, result));
  return result;
};

export const deleteModel = id => async dispatch => {
  const result = await fetch(`${conf.apiRoot}/api/models/${id}`, {
    credentials: 'include',
    method: 'DELETE',
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result && result.status === 'ok') {
    dispatch(deleteModelFromState(id));
  }
  return result;
};

export const exportModel = (modelId, ext, version) => async dispatch => {
  const result = await fetch(
    `${conf.apiRoot}/api/models/${modelId}/export?extension=${ext}&version=${version}`,
    {
      credentials: 'include',
    }
  ).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result && result.status === 'ok') {
    return result.result;
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/modules/models.js